const PIPELINES_PATH = '/pipelines';
const STEPS_PATH = '/steps';
const CREATE_NEW_STEP_DETAILS = `${PIPELINES_PATH}/new/step-details`;

export const PIPELINES_AND_STEPS_PATHS = {
    LANDING_PAGE: PIPELINES_PATH,
    CREATE_NEW_PIPELINE: `${PIPELINES_PATH}/new/pipeline`,
    PIPELINE_DETAILS: `${PIPELINES_PATH}/edit/:id`,
    CREATE_NEW_STEP: `${PIPELINES_PATH}/new/step`,
    CREATE_NEW_STEP_DETAILS,
    CREATE_FIELD_MAPPING: `${CREATE_NEW_STEP_DETAILS}/field-mapping`,
    CREATE_RULE_SET: `${CREATE_NEW_STEP_DETAILS}/rule-set`,
    UPDATE_STEP_DETAILS: `${STEPS_PATH}/edit/:id`,
};
